import { IEnumerable } from './types';

/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */

/**
 * Get the set difference between two iterable elements.
 *
 * @param lhs Left-hand side operand.
 * @param rhs Right-hand side operand.
 * @returns An array made of all the elements in `lhs` that don't belong to `rhs`.
 */
export function difference<T>(lhs: IEnumerable<T>, rhs: IEnumerable<T>): T[] {
    const diff: T[] = [];
    const map = new Map<T, null>();

    rhs.forEach(value => {
        map.set(value, null);
    });

    lhs.forEach(value => {
        if (!map.has(value)) {
            diff.push(value);
        }
    });

    return diff;
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/collections/operators.ts